
document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.blog-product-carousel-container');
    const carousel = document.querySelector('.blog-product-carousel--outer-wrapper');

    if (container && carousel) {
        console.log('Blog product carousel container found, moving element into container');
        container.appendChild(carousel);
    } else {
        console.debug('.blog-product-carousel-container is not inside blog content, rendering carousel after author section');
    }
});